import React from 'react';
import { IncidentBoard } from '../../components/incidents/IncidentBoard';

export const IncidentBoardPage = ({ user }: { user: any }) => (
  <div className="p-4 md:p-6">
    <div className="mb-5">
      <h1 className="text-2xl font-bold text-white mb-1">Gestion des incidents</h1>
      <p className="text-gray-400 text-sm">Tableau de bord en temps réel · Actualisation automatique toutes les 30 secondes</p>
    </div>
    <IncidentBoard user={user} />
  </div>
);
